<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"  display: flex;\n  justify-content: center;\npadding-bottom:80px;"' class="rcontainer" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='" width: 480px; \/* \u0639\u0631\u0636 \u06a9\u0627\u0646\u062a\u06cc\u0646\u0631 \u0645\u062e\u0635\u0648\u0635 \u0645\u0648\u0628\u0627\u06cc\u0644 *\/\nheight:100%;\n\n\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n"' class="inner-container bg-white shadow" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>پروفایل   </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.mybarco.ir\/storage\/assets\/Sprinkle (1).svg\");\nheight:100vh;"' class="container-fluid p-0 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row pb-5 p-0 m-0 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12  text-center" >
                <template #default>   <m-complete-profile-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-complete-profile-message-1><m-user-profile-1 v-bind='{...{"advanceDescription":true,"advanceDescriptionInputs":"","loadUserProfile":false},...{}}' :style='"border:1px solid #cfcfcf;\nborder-radius:15px"' class="bg-white m-2 p-4 profile-sec" ></m-user-profile-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mCompleteProfileMessage1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Message/CompleteProfileMessage1'; import mUserProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/Profile/UserProfile1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mCompleteProfileMessage1,mUserProfile1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
